import React from "react";
// @ts-ignore
import P5Wrapper from "react-p5-wrapper";
import sketch from "../../sketches/Home/Home";
import classes from "./Home.module.css";

const Home: React.FC = () => {
    return (
        <div className={classes.Home}>
            <P5Wrapper sketch={sketch} key={"HomeSketch"} />
        </div>
    );
};

export default Home;
